<!-- 首页-实训中心模块 -->
<template>
  <div class="training-ai-content">
    <homeModuleHead :apply="apply"></homeModuleHead>
    <div class="training-center">
      <ul>
        <li v-for="(item, index) in trainingCenterList" :key="index">
          <img :src="item.image" alt="">
          <p class="training-center-title">{{item.title}}</p>
          <p class="training-center-introduce">
            <span :class="[`span${index+1}`]">{{item.titleSketchList[0]}}</span>{{item.titleSketchList[1]}}
          </p>
        </li>
      </ul>
      <!-- <div class="training-description">
        <div class="description" v-for="(item, index) in trainingList" :key="index">
          <p>{{item.title}}</p>
          <div class="description-content">
            <span v-for="(itm, idx) in item.titleSketchList" :key="idx">{{itm}}</span>
            <img :src="item.image" />
          </div>
        </div>
      </div> -->
    </div>
  </div>

</template>

<script>
import homeModuleHead from './HomeModuleHead.vue' // 头部
import { experienceAiImg } from "@/utils/images.js";

export default {
  name: "training",
  components: {homeModuleHead},
  props: {},
  data() {
    return {
      apply: {
        titleEnglish: ['PRACTICAL', 'TRAINING CENTER'],
        title: '实训中心',
        intro: "零编程基础入门，调用多种AI模型，智能硬件联动",
        more: "进入实训",
        redirect: "/training/trainingproject", // TIPS:  2 是模型训练里面的其中一个，图像分类
        openUrl: "application"
      },
      experienceAiImg: experienceAiImg, //图片
      trainingCenterList: [
        {
          title: 'AI实训备课教学更便捷',
          titleSketchList: ['线', '上实训备课、项目题面、项目题解、项目任务书、项目指导书…'],
          image: require("../../../public/images/home/trainingCenter-bg01.png")
        },
        {
          title: 'AI实训类型选择更灵活',
          titleSketchList: ['算', '法编程应用、智能硬件应用、数据标注应用、行业创研应用…'],
          image: require("../../../public/images/home/trainingCenter-bg02.png")
        },
        {
          title: 'AI算法模型资源更丰富',
          titleSketchList: ['物', '体检测、图像分类、语音识别、文字识别、语音合成、图像特效…', '...'],
          image: require("../../../public/images/home/trainingCenter-bg03.png")
        },
      ],
      trainingList: [
        {
          title: '灵活的实训项目设计',
          titleSketchList: ['项目题解', '项目题面', '任务书', '指导书', '...'],
          image: require("../../../public/images/home/training-2.png")
        },
        {
          title: '可选择的多种实训类型',
          titleSketchList: ['云实训', '实操实训', '创研实训', '...'],
          image: require("../../../public/images/home/training-1.png")
        },
        {
          title: '持续更新的AI模型库',
          titleSketchList: ['物体检测', '图像分类', '语音识别', '文字识别', '语音合成', '图像特效', '...'],
          image: require("../../../public/images/home/training-3.png")
        },
      ]
    };
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    onGoToTraining() {
      this.$router.push("/training/trainingproject");
    },
    goToExperienceAi() {
    }
  },
  updated() {
  },
  destroyed() {
  },
  activated() {
  }
};
</script>
<style lang="scss" scoped>
%flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

%flex-start {
  display: flex;
  justify-content: start;
  align-items: center;
}

%flex-bewteen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .el-divider--horizontal {
  width: 45px;
  background: rgba(0,0,0,0.67);
  opacity: 0.6;
}

div {
  box-sizing: border-box;
}

.training-ai-content {
  // background: url(../../../public/images/home/teaching/teaching-bg.png);
  // background: linear-gradient(90deg, #8678F5, #2D8EF2);
  background: #E7E7F3;

  .training-center {
    width: 1200px;
    height: 690px;
    padding: 145px 0 0;
    margin: 0 auto;
    position: relative;
    
    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      li {
        width: 358px;
        height: 376px;
        position: relative;
        img {
          width: 100%;
          height: 100%
        }
        .training-center-title {
          font-size: 23px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 35px;
          position: absolute;
          top: 12px;
          left: 14px;
        }
        .training-center-introduce {
          // width: 456px;
          width: 100%;
          height: 122px;
          color: #22374C;
          font-size: 18px;
          line-height: 28px;
          position: absolute;
          left: 0;
          bottom: 0;
          text-align: left;
          padding: 34px 30px;
          box-sizing: border-box;
          .span1 {
            color: #64BCEE;
            font-size: 24px;
          }
          .span2 {
            color: #00D6B4;
            font-size: 24px;
          }
          .span3 {
            color: #F6C255;
            font-size: 24px;
          }
        }
      }
    }

    .title-wrap {
      @extend %flex-center;
      .title {
        color: #FDFDFF;
        display: block;
        min-width: 120px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        line-height: 36px;
        margin: 0 30px;

      }

      .el-divider--horizontal {
        background: rgba(255, 255, 255, 0.8);
      }
    }

    .title-sketch {
      width: 100%;    
      color: #FFFFFF; 
      font-size: 18px;
      text-align: center;
      margin: 40px 0 50px;
      position: relative;
      span:nth-child(2) {
        font-size: 16px;
        font-weight: 400;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        &:hover {
          // color: #4c99ff;
          color: #185297;
        }
      }
    }

    .left-wrap {
      width: 700px;
      height: 500px;
      @extend %flex-start;
      //margin-left: 75px;
    }

    .right-wrap {
      width: 435px;
      color: #fff;
      text-align: start;

      .title {
        font-size: 36px;
        margin: 100px 0 16px 0;
        // &:hover{
        //   color:#3c7dff;
        // }
      }

      .text {
        width: 433px;
        height: 234px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #E6EDFD;
      }

      .btn-to-experience {
        float: right;
        width: 150px;
        height: 50px;
        color: #333333;
        background: #FFFFFF;
        border: 1px solid #4C88FF;
        border-radius: 3px;
        @extend %flex-center;
        bottom: 0;
        cursor: pointer;
      }
    }

    .training-description {
      width: 100%;
      display: flex;
      justify-content: center;
      // align-items: center;
      // margin: 0 auto;
      .description {
        display: flex;
        flex-direction: column;
        margin-right: 73px;
        p {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 16px;
        }
        .description-content {
          width: 258px;
          height: 500px;
          background: url('../../../public/images/home/training-5.png') no-repeat;
          padding-top: 138px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          span {
            width: 72px;
            font-size: 18px;
            color: #fff;
            text-align: left;
            line-height: 24px;
          }
          img {
            width: 104px;
            height: 128px;
            position: absolute;
            bottom: 64px;
          }
        }
      }
      .description:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
